import dayjs from 'dayjs';

export const calculateAge = (dob) => {
    const now = dayjs();
    const age = now.diff(dob, 'year');

    return age;
};
